export default function BackArrow() {
  return (
    <svg width='12.727' height='9.906' viewBox='0 0 12.727 9.906'>
      <path
        id='f105'
        d='M9.581,8.786,5.785,12.4a1.126,1.126,0,0,1-.832.325,1.082,1.082,0,0,1-.8-.325L.325,8.786a1.091,1.091,0,0,1,0-1.555,1.126,1.126,0,0,1,.832-.325,1.126,1.126,0,0,1,.832.325L3.8,8.966V1.121a1.054,1.054,0,0,1,.343-.8,1.18,1.18,0,0,1,1.627,0,1.054,1.054,0,0,1,.343.8V8.966L7.918,7.231a1.225,1.225,0,0,1,1.663,0,1.091,1.091,0,0,1,0,1.555Z'
        transform='translate(12.727) rotate(90)'
        fill='#fff'
      />
    </svg>
  )
}
